import { useState } from "react";
import { Box, ButtonBase, Collapse, Container, Typography } from "@mui/material";
import { useTranslation } from "react-i18next";
import {
  colorLandingBrand,
  colorLandingInk,
  colorLandingLine,
  colorLandingMuted,
  fontLandingSans,
} from "src/design/tokens";
import { SectionHeading } from "./components/SectionHeading";

const QUESTION_KEYS = [
  "modules",
  "setup",
  "whatsapp",
  "commission",
  "multiRestaurant",
  "offPeak",
  "commitment",
];

/** Accordion of the questions the sales team fields most often. */
export const FAQSection = () => {
  const { t } = useTranslation();
  const [openKey, setOpenKey] = useState<string | null>(null);

  return (
    <Box
      component="section"
      id="faq"
      sx={{ py: { xs: 8, md: 11.5 }, borderTop: `1px solid ${colorLandingLine}` }}
    >
      <Container maxWidth="lg">
        <SectionHeading title={t("landingPage.faq.title")} />

        <Box sx={{ maxWidth: 800, mx: "auto", mt: 5.75 }}>
          {QUESTION_KEYS.map((key) => {
            const open = openKey === key;
            return (
              <Box key={key} sx={{ borderBottom: `1px solid ${colorLandingLine}` }}>
                <ButtonBase
                  onClick={() => setOpenKey(open ? null : key)}
                  aria-expanded={open}
                  sx={{
                    width: "100%",
                    textAlign: "left",
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                    gap: 2,
                    px: 0.5,
                    py: 2.75,
                    fontFamily: fontLandingSans,
                  }}
                >
                  <Typography
                    component="span"
                    sx={{ fontWeight: 700, fontSize: 17, color: colorLandingInk }}
                  >
                    {t(`landingPage.faq.${key}.q`)}
                  </Typography>
                  <Box
                    component="span"
                    aria-hidden="true"
                    sx={{
                      color: colorLandingBrand,
                      fontSize: 22,
                      flexShrink: 0,
                      lineHeight: 1,
                      transition: "transform .2s",
                      transform: open ? "rotate(45deg)" : "none",
                    }}
                  >
                    +
                  </Box>
                </ButtonBase>

                <Collapse in={open} unmountOnExit>
                  <Typography
                    sx={{
                      px: 0.5,
                      pb: 2.75,
                      color: colorLandingMuted,
                      fontSize: 15,
                      lineHeight: 1.65,
                    }}
                  >
                    {t(`landingPage.faq.${key}.a`)}
                  </Typography>
                </Collapse>
              </Box>
            );
          })}
        </Box>
      </Container>
    </Box>
  );
};
